import { asyncRouterMap, constantRouterMap } from '@/router'
// import user from './user'
/**
 * 通过meta.role判断是否与当前用户权限匹配
 * @param roles
 * @param route
 */
function hasPermission(roles, route) {
  if (roles) {
    var routerarr = []
    roles.forEach(localroute => {
      route.forEach(item => {
        item.ProgramInfos.forEach(item_ => {
          if (item_.PgUrl === localroute.path) {
            routerarr.push(localroute)
          }
        })
      })
    })
    return routerarr
    // return roles.some(role => {
    //   if (route.path === role.ProgramInfos.PgUrl) {
    //     return route
    //   }
    // })
  } else {
    return false
  }
}

/**
 * 递归过滤异步路由表，返回符合用户角色权限的路由表
 * @param routes asyncRouterMap
 * @param roles
 */
function filterAsyncRouter(routes, roles) {
  const res = []
  routes.forEach(route => {
    const tmp = { ...route }
    if (tmp.children && tmp.children.length > 0) {
      if (hasPermission(tmp.children, roles) && hasPermission(tmp.children, roles).length > 0) {
        tmp.children = hasPermission(tmp.children, roles)
        res.push(tmp)
      }
    }
  })

  return res
}
const permission = {
  state: {
    routers: constantRouterMap,
    addRouters: []
  },
  mutations: {
    SET_ROUTERS: (state, routers) => {
      state.addRouters = routers
      state.routers = constantRouterMap.concat(routers)
    }
  },
  actions: {
    GenerateRoutes({ commit }, data) {
      return new Promise(resolve => {
        const { roles } = data
        console.log('66', roles)
        var accessedRouters = filterAsyncRouter(asyncRouterMap, roles)
        commit('SET_ROUTERS', accessedRouters)
        resolve()
      })
    }
  }
}

export default permission
